import { ReactNode } from 'react';

import { SsrConfig } from 'ssr/types/SsrConfig';
import { setConfigOnce } from 'utils/config';

type Props = {
  config: SsrConfig;
  children: ReactNode;
};

export function WithConfig({ config, children }: Props) {
  setConfigOnce(config);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
